import {DataFetcher} from '@aboutyou/data-fetcher';
import React from 'react';
import {useLinksSection} from '../useGetProductBulkSection';
import {
  BackToCategoryBarProps,
  BackToCategoryBarView,
} from './BackToCategoryBarView';

export const BackToCategoryBar: React.FC<BackToCategoryBarProps> = props => {
  return (
    <DataFetcher
      request={useLinksSection()}
      Error={null}
      Loading={BackToCategoryBarView}
      View={BackToCategoryBarView}
      viewProps={props}
    />
  );
};
